import { render, staticRenderFns } from "./ModelBox.vue?vue&type=template&id=100a1db6&"
import script from "./ModelBox.vue?vue&type=script&lang=js&"
export * from "./ModelBox.vue?vue&type=script&lang=js&"
import style0 from "./ModelBox.vue?vue&type=style&index=0&id=100a1db6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports